import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import Intervention from "../../entity/emergency/Intervention";
import axios from "axios";
import isNull from "../../mixin/isNull";
import useEmergencyInterventionDemo
    from "../../component/private/intervention/emergency/demo/useEmergencyInterventionDemoServer";

const SERVICE = "service-emergency";
const ENTITY = "interventions";

/**
 * @rule-checker exclude
 * @returns {{select(): (null|*), exec(): (undefined|*|void|null|boolean|undefined)}|Promise<*|null|undefined>|*|{select(): (null|*), exec(): Promise<undefined|*|void|null|boolean>}|null|void|boolean|{select(): (null|*), exec(): Promise<*|null|undefined>}|{findOneById(*): {select(): (null|*), exec(): Promise<undefined|*|void|null|boolean>}, findOneBySuggestion(*): {select(): (null|*), exec(): Promise<*|null|undefined>}, findOneByToken(*): {select(): (null|*), exec(): (undefined|*|void|null|boolean|undefined)}, getSupportedPriceByOrder: function(*): Promise<[]|any|boolean|undefined>, getClientInvoiceDetails: function(*): Promise<[{quantity: number, price: number, name: string},{quantity: number, price: number, name: string},{quantity: number, price: number, name: string},{quantity: number, price: number, name: string},{quantity: number, price: number, name: string}]|any|[]|undefined>, update(*, *, *): Promise<boolean|undefined>}|Promise<boolean|undefined>}
 */
export default function () {
    const {findOneBy, update} = useApi();
    const state = useSelector;
    const newInstance = data => new Intervention(data);
    const demo = useEmergencyInterventionDemo();

    return {
        findOneById(id) {
            return {
                select() {
                    const result = state(state => state.api?.emergency?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                async exec() {
                    if (demo.isLockRequest()) {
                        return demo.handleRequest("GET", SERVICE, ENTITY, "id", id);
                    }

                    return findOneBy(SERVICE, ENTITY, "id", id, newInstance, "application_v7");
                }
            }
        },
        findOneBySuggestion(id) {
            return {
                select() {
                    const result = state(state => state.api?.emergency?.[ENTITY]?.find(s => s?.getSuggestionId() === id));

                    if (isNull(result)) return null;

                    return result;
                },
                async exec() {
                    return findOneBy(SERVICE, ENTITY, "suggestion_id", id, newInstance, "application_v7");
                }
            }
        },
        findOneByToken(token) {
            return {
                select() {
                    const result = state(state => state.api?.emergency?.[ENTITY]?.find(s => s?.getToken() === token));

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    if (demo.isLockRequest()) {
                        return demo.handleRequest("GET", SERVICE, ENTITY, "token", token);
                    }

                    findOneBy(SERVICE, ENTITY, "token", token, newInstance, "application_v7");
                }
            }
        },
        getSupportedPriceByOrder: async id => {
            if (demo.isLockRequest()) {
                return [];
            }

            try {
                const response = await axios.get(process.env.REACT_APP_API_URL + `/service-emergency/application_v7/interventions/supported_price/by/order/${id}`);

                return response.data;
            } catch (e) {
                console.log(e.message);
                return false;
            }
        },
        getClientInvoiceDetails: async id => {
            if (demo.isLockRequest()) {
                return demo.getClientPriceInvoiceDetails();
            }

            try {
                const response = await axios.get(process.env.REACT_APP_API_URL + `/service-emergency/application_v7/interventions/${id}/client_price_invoice`);

                return response.data;
            } catch (e) {
                console.log(e.message);
                return [];
            }
        },
        async update(id, property, payload) {
            if (demo.isLockRequest()) {
                return true;
            }

            return update(SERVICE, ENTITY, id, property, payload, newInstance, "application_v7");
        },
    }
}